<div class="registro div-expand" [ngClass]="{'print-page':print}">
  <h3>Ata</h3>
  <form class="d-flex row overflow-hidden"  [formGroup]="form" (ngSubmit)="saveNotes()" (keydown.enter)="$event.stopPropagation()">
        
    <div class="div-expand" [ngClass]="{'col-md-8':!print}">
      <textarea class="form-control" formControlName="notes" *ngIf="!print"></textarea>
      <p  *ngIf="print"  style="white-space: pre-line;">
        {{entity.acMeeting?.notes}}
      </p>
    </div>
    <div class="div-report div-expand" [ngClass]="{'col-md-4':!print}" *ngIf="!print">
      <h4>Último relatório</h4>    
      <a  (click)="download()" class="report-link">
        {{lastReport?.name}}
      </a>
      <span class="history-result">
        Nenhum registro
      </span>
      
      <h4>Última atualização</h4>    
      <span *ngIf="audits.length > 0" class="history-result"> 
        {{audits[0]?.tb_pss_pessoa?.str_nome }} ({{audits[0]?.dt_create | date: 'dd/MM/YYYY - H:mm:s'}})
      </span>
      <span *ngIf="audits.length == 0" class="history-result">Nenhum registro</span>

      <mat-accordion class="flex-grow-1 mb-0" [togglePosition]="'before'">
        <mat-expansion-panel class="session mb-0" [expanded]="print">
          <mat-expansion-panel-header  class="session-title  py-2 ">
            <mat-panel-title class="d-flex justify-content-between row">
              <h4 *ngIf="!print">Ver histórico de atualizações</h4>    
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <section *ngFor="let history of audits" class="history-data">
              Por <b>{{history?.tb_pss_pessoa?.str_nome}}</b> em 
              {{history?.dt_create | date: 'dd/MM/YYYY - H:mm:s'}}<br>
              {{history?.summary}}
            </section>
            <span *ngIf="loadAudits">
              Carregahdo histórico...
            </span>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <div class="row g-0 justify-content-between" *ngIf="!print && !saving">
        <button class="btn col-sm-5 mt-1" type="submit">Salvar Ata</button>
        <button class="btn col-sm-6 mt-1" type="button" (click)="saveReport()">Salvar Relatório</button>
        <button class="btn col-sm-12 mt-1" type="button" (click)="sendReport()">
          Enviar relatório aos participantes
        </button>
      </div>
      <div class="row g-0 justify-content-between" *ngIf="saving">
        O relatório ainda está sendo salvo, aguarde mais um pouco.
      </div>
    </div>
  </form>
</div>
<app-loading [loader]="isLoading"></app-loading>
<div class="relatorio-div">
  <app-apresentacao-relatorio *ngIf="printMeeting" #relatorio id="relatorio" (generatePDF)="generatePDF()"></app-apresentacao-relatorio>
</div>